import { render, staticRenderFns } from "./CertificadoReport.vue?vue&type=template&id=26f676c0&scoped=true"
import script from "./CertificadoReport.vue?vue&type=script&lang=js"
export * from "./CertificadoReport.vue?vue&type=script&lang=js"
import style0 from "./CertificadoReport.vue?vue&type=style&index=0&id=26f676c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f676c0",
  null
  
)

export default component.exports